import { ArrowNavigation } from 'components/ArrowNavigation';
import { Box } from 'components/Box';
import { DotNavigationButton } from 'components/Button';
import { CarouselState } from 'components/Carousel';
import { Flex } from 'components/Flex';
import { range } from 'utils/functional';

type Props = {
  carouselState: CarouselState;
};

export function TileCarouselNavigation({ carouselState }: Props) {
  const { currentPage, pageCount, goToPage, goToPreviousPage, goToNextPage } =
    carouselState;

  return (
    <nav>
      <ArrowNavigation
        nextPage={goToNextPage}
        prevPage={goToPreviousPage}
        current={currentPage}
        total={pageCount}
        outset
      />

      {pageCount > 1 && (
        <Box position="relative" height={32}>
          <Flex
            position="absolute"
            bottom={0}
            left="50%"
            transform="translateX(-50%)"
            justifyContent="center"
            maxWidth="calc(100vw - 16px)"
          >
            {range(pageCount).map((index) => (
              <DotNavigationButton
                key={index}
                goToPage={goToPage}
                index={index}
                $isActive={index === currentPage}
              />
            ))}
          </Flex>
        </Box>
      )}
    </nav>
  );
}
